module.exports = __webpack_public_path__ + "static/media/sort-numeric-down.80b9605f.svg";